import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

const EnrolledCourses = () => {
  const [studentData, setStudentData] = useState([]);
  const [enCourse, setEncourses] = useState([]);
  const { id } = useParams();
  const uname = JSON.parse(localStorage.getItem('uname'));
  const AuthStr = process.env.REACT_APP_AUTH_STR;
  const fetchUrl = `https://stucharge.bakersbrisk.com/api/getspecificstudentsapi?username=${uname}&phone=${id}`;

  useEffect(() => {
    const fetchData = async () => {
      const result = await axios.get(fetchUrl, {
        headers: { Authorization: AuthStr },
      });
      if (result.status === 200) {
        setEncourses(result.data.enrolled_courses);
        setStudentData(result.data);
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className='students'>
      <h1 className='text-title'>Student Details</h1>
      <div className='user-details student'>
        <div className='detail'>
          <h2>Name</h2>
          <p>{studentData.name}</p>
        </div>
        <div className='detail'>
          <h2>Email</h2>
          <p>{studentData.email}</p>
        </div>
        <div className='detail'>
          <h2>Contact</h2>
          <p>{studentData.phone}</p>
        </div>
        <div className='detail' style={{ justifyContent: 'center' }}>
          <h2>Courses Details</h2>
        </div>

        {enCourse.length > 0 ? (
          <div className='table-container' style={{ margin: '0 auto' }}>
            <table className='table' style={{ width: '100%' }}>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Price</th>
                  <th>Title</th>
                </tr>
              </thead>
              <tbody>
                {enCourse.map((item, index) => (
                  <tr key={item.id} style={{ transform: 'none' }}>
                    <td data-label='#'>{index + 1}</td>
                    <td data-label='Price'>
                      {item.course.price === 0
                        ? 'Free'
                        : `₹${item.course.price}`}
                    </td>
                    <td data-label='Title' className='text-title'>
                      {item.course.title}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <h2 className='text-red' style={{ textAlign: 'center' }}>
            Student not enrolled in any course
          </h2>
        )}
      </div>
    </div>
  );
};

export default EnrolledCourses;
